/* ==================================================================
   ISCA - two-step signposting on product pages
   ------------------------------------------------------------------
   Adds, without touching the 16KB size-quantity-grid block:

     1. "Step 1 of 2" above the Size & Quantities heading
     2. "Step 2 of 2" inside the after-add confirmation panel
     3. A "No thanks" button beside Add your logo / View Basket

   School products are handled differently on purpose. There, Step 2 is
   the name embroidery panel (which badges itself), and the logo prompt
   is hidden entirely because the school badge is already in the price.
   Detected by the presence of .isca-ne on the page.

   markStepOne() shares the data-isca-stepped flag with
   isca-name-embroidery.js, so whichever runs first wins and the badge
   is never added twice.
   ================================================================== */

(function () {
  function grid() {
    return document.querySelector('[id^="sqg-"]');
  }

  function isSchoolProduct() {
    return !!document.querySelector('.isca-ne');
  }

  function badge(text) {
    var el = document.createElement('span');
    el.className = 'isca-ne__step';
    el.textContent = text;
    return el;
  }

  function markStepOne() {
    var g = grid();
    if (!g || g.dataset.iscaStepped === '1') return;

    var heading = g.querySelector('h1, h2, h3, h4');
    if (!heading || !heading.parentNode) return;

    g.dataset.iscaStepped = '1';
    heading.parentNode.insertBefore(badge('Step 1 of 2'), heading);
  }

  function markStepTwo() {
    // School products get their Step 2 from the name embroidery panel.
    if (isSchoolProduct()) return;

    var panel = document.querySelector('.sqg__confirm');
    if (!panel || panel.dataset.iscaStepped === '1') return;

    panel.dataset.iscaStepped = '1';
    panel.insertBefore(badge('Step 2 of 2'), panel.firstChild);

    var actions = panel.querySelector('.sqg__confirm-actions');
    if (!actions || actions.querySelector('.isca-sqg-nothanks')) return;

    // Only offer "No thanks" if there is a logo prompt to decline.
    if (!actions.querySelector('.sqg__confirm-logo')) return;

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'isca-sqg-nothanks';
    no.textContent = 'No thanks';
    no.setAttribute('aria-label', 'No logo - carry on shopping');

    no.addEventListener('click', function () {
      // Dismiss and stay put, so someone kitting out a team can keep
      // adding sizes. View Basket already covers leaving the page.
      panel.hidden = true;
    });

    actions.appendChild(no);
  }

  function boot() {
    markStepOne();
    markStepTwo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The size grid re-renders after add-to-cart and in the theme editor.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
  document.addEventListener('cart:update', function () {
    setTimeout(boot, 0);
  });
})();
